var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',{attrs:{"is-load-data":_vm.isLoading,"is-loading":_vm.isLoading,"variant":_vm.panelVariant}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }